﻿import config from "../config"
const baseUrl = config.base_url + "lz_period_mature_time_manager/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    matureTypeList: {
        url:  baseUrl + "matureTypeList",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    }
}

